import React, { useRef, useState } from "react"
import { Pause, Play, SkipBack, SkipForward } from "react-feather"
import { Alert, Button, Modal, ModalBody, ModalHeader } from "reactstrap"
import PBPCourt from "./PBPCourt"
import styles from "./PlayByPlay.module.scss"
import { useSelector } from "react-redux"

// Having a variable was not the most efficient way of doing it but it was a quick and easy solution
let timeout
function PlayByPlay() {
	const events = useSelector((state) =>
		state.events.filter((ev) => ev.coordinates)
	)
	
	const [isOpen, setIsOpen] = useState(true)
	const [eventIndex, setEventIndex] = useState(0)
	const [eventIndexWentUp, setEventIndexWentUp] = useState(0) // Used to see what event needs to disappear from court
	const [shouldPlayNext, setShouldPlayNext] = useState()
	const shouldPlayNextRef = useRef()
	shouldPlayNextRef.current = shouldPlayNext
	const eventIndexRef = useRef()
	eventIndexRef.current = eventIndex

	const onChangeSliderValue = ({ target }) => {
		setShouldPlayNext()
		if (target.value != eventIndex) setEventIndex(parseInt(target.value))
	}

	const onEventBack = () => {
		setEventIndex(eventIndex - 1)
		if (shouldPlayNext) setShouldPlayNext()
		if (eventIndexWentUp) setEventIndexWentUp(false)
	}

	const onEventForward = () => {
		setEventIndex(eventIndex + 1)
		if (shouldPlayNext) setShouldPlayNext()
		if (!eventIndexWentUp) setEventIndexWentUp(true)
	}

	const togglePlay = () => {
		if (shouldPlayNext) {
			setShouldPlayNext()
			clearTimeout(timeout)
		} else {
			setEventIndex(eventIndex + 1)

			if (eventIndex + 2 >= events.length) return
			if (!eventIndexWentUp) setEventIndexWentUp(true)
			setShouldPlayNext(true)
			timeout = setTimeout(doPlayFunctionality, 3000)
		}
	}

	const doPlayFunctionality = () => {
		if (!shouldPlayNextRef.current) return

		setEventIndex(eventIndexRef.current + 1)
		if (eventIndexRef.current + 1 >= events.length) {
			setShouldPlayNext(false)
		} else {
			timeout = setTimeout(doPlayFunctionality, 3000)
		}
	}

	return (
		<>
			<div className={`${styles.playByPlayButton} box-shadow-6`}>
				<Button.Ripple
					color="relief-primary"
					className="round"
					size="lg"
					onClick={() => setIsOpen(true)}
				>
					Play By Play
				</Button.Ripple>
			</div>

			<Modal
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
				className="modal-xl"
			>
				<ModalHeader toggle={() => setIsOpen(false)}>
					Play By Play
				</ModalHeader>
				<ModalBody>
					<PBPCourt
						events={events}
						eventIndex={eventIndex}
						eventIndexWentUp={eventIndexWentUp}
					/>

					{events.length > 0 ? (
						<>
							<div className={styles.controlls}>
								<Button.Ripple
									className="btn-icon rounded-circle"
									color="primary"
									size="sm"
									outline
									onClick={onEventBack}
									disabled={eventIndex <= 0}
								>
									<SkipBack />
								</Button.Ripple>
								<Button.Ripple
									className="btn-icon rounded-circle"
									color="primary"
									size="lg"
									outline
									onClick={togglePlay}
									disabled={eventIndex >= events.length - 1}
								>
									{shouldPlayNext ? <Pause /> : <Play />}
								</Button.Ripple>
								<Button.Ripple
									className="btn-icon rounded-circle"
									color="primary"
									size="sm"
									outline
									onClick={onEventForward}
									disabled={eventIndex >= events.length - 1}
								>
									<SkipForward />
								</Button.Ripple>
							</div>
							<div className={styles.rangeWrapper}>
								<input
									type="range"
									min="0"
									max={events.length - 1}
									className="custom-range"
									value={eventIndex}
									onChange={onChangeSliderValue}
								/>
							</div>
							<Alert color="primary">
								<h4 className="alert-heading">
									{events[eventIndex]?.event}
								</h4>
								<div className="alert-body">
									{events[eventIndex]?.comment}
								</div>
							</Alert>
						</>
					) : (
						<Alert color="warning">
							<h4 className="alert-heading">Nema dovoljno evenata</h4>
							<div className="alert-body">
								Nije uveden ni jedan event sa koordinatama
							</div>
						</Alert>
					)}
				</ModalBody>
			</Modal>
		</>
	)
}

export default PlayByPlay
